<div class="form-container">
    <form [formGroup]="movementScheduleForm">
        <div formArrayName="selectedFlis">
            <div
                class="notesFliCompontent"
                *ngFor="
                    let selectedFliControl of movementScheduleForm.get('selectedFlis')['controls'];
                    let selectedFliControlIndex = index
                "
                [ngClass]="{ aumPreview: viewMode === 1 }"
            >
                <div [formGroupName]="selectedFliControlIndex">
                    <div class="form-group form-fields">
                        <div *ngIf="viewMode === 2" class="input-wrapper">
                            <input
                                hamSimpleDropDown
                                [options]="getAvailableMovementsScheduleFlis(selectedFliControlIndex)"
                                [optionKeys]="[propertyOfMovementScheduleFliOptionsToDisplay]"
                                returnKey="translatedCaption"
                                [returnObject]="true"
                                [placeholder]="'aumico_notes_fli_selection_placeholder' | i18next"
                                [multiple]="false"
                                [formControl]="selectedFliControl['controls']['fli']"
                                (selectionChange)="onSelectionChanged($event, selectedFliControlIndex)"
                                (clear)="onRemoveSelection(selectedFliControlIndex)"
                            />
                        </div>
                        <div class="form-fields">
                            <span
                                *ngIf="editable && viewMode === 2"
                                class="ham-icon numbering-icon"
                                [ngClass]="{
                                    on:
                                        tableNumbers?.[getTableNumberIndex(selectedFliControlIndex)] != null &&
                                        tableNumbers?.[getTableNumberIndex(selectedFliControlIndex)] !== '',
                                    disabled:
                                        selectedMovementsScheduleFlis?.size === 0 ||
                                        selectedMovementsScheduleFlis.get(selectedFliControlIndex) == null || selectedMovementsScheduleFlis.get(selectedFliControlIndex)?.accounts == null || selectedMovementsScheduleFlis.get(selectedFliControlIndex)?.accounts.length === 0 
                                }"
                                (click)="
                            onAddNumberToggleChange(
                                !(
                                    tableNumbers?.[getTableNumberIndex(selectedFliControlIndex)] != null &&
                                    tableNumbers?.[getTableNumberIndex(selectedFliControlIndex)] !== ''
                                ),
                                selectedFliControlIndex
                            );
                            setNumberingToFli(!(tableNumbers?.[getTableNumberIndex(selectedFliControlIndex)] != null &&
                            tableNumbers?.[getTableNumberIndex(selectedFliControlIndex)] !== ''), selectedFliControlIndex)
                        "
                            >
                                <i class="ordered-list-outline-icon"></i>
                            </span>

                            <span *ngIf="viewMode === 2">
                                <span
                                    class="remove-icon"
                                    hamIconShapes
                                    variant="transparent"
                                    icon="assets/hamIcons/minus-outline.svg"
                                    size="xs"
                                    (click)="openFliDeletionConfirmationDialog(selectedFliControlIndex)"
                                >
                                </span>
                            </span>
                        </div>
                    </div>

                    <aumico-notes-movements-schedule-table
                        *ngIf="
                            selectedFliControl['controls']['fli']?.value?.id !== '' &&
                            selectedFliControl['controls']['fli']?.value != null
                        "
                        [dates]="dates"
                        [reportLocale]="reportLocale"
                        [fliData]="selectedFliControl['controls']['fli']?.value"
                        [mode]="viewMode"
                        [highlightTodos]="highlightTodos"
                        [tableNumber]="tableNumbers?.[getTableNumberIndex(selectedFliControlIndex)]"
                        [defaultLanguage]="defaultLanguage"
                        [hasFootnotes]="hasFootnotes"
                        [savedFootnote]="updatedMovementScheduleComponentData.footnotes?.[selectedFliControlIndex]"
                        (movementScheduleTableData)="
                            updateSelectedMovementScheduleFliData($event, selectedFliControlIndex)
                        "
                    ></aumico-notes-movements-schedule-table>
                </div>
                <div *ngIf="previousMovementScheduleComponent != null">
                    <div
                        *ngIf="
                            previousMovementScheduleComponent.flis.length !== 0 &&
                            previousSelectedMovementScheduleFlis[selectedFliControlIndex] != null
                        "
                    >
                        <aumico-notes-movements-schedule-table
                            [dates]="datesOfPreviousYear"
                            [reportLocale]="reportLocale"
                            [fliData]="previousSelectedMovementScheduleFlis[selectedFliControlIndex]"
                            [mode]="viewMode"
                            [defaultLanguage]="defaultLanguage"
                            [highlightTodos]="highlightTodos"
                            [hasFootnotes]="hasFootnotes"
                            [editableData]="false"
                            [savedFootnote]="previousMovementScheduleComponent.footnotes?.[selectedFliControlIndex]"
                            (movementScheduleTableData)="
                                updatePreviousMovementScheduleFliData($event, selectedFliControlIndex)
                            "
                        ></aumico-notes-movements-schedule-table>
                    </div>
                </div>
                <div class="add-component-section">
                    <div class="line"></div>
                    <ham-button
                        icon="assets/hamIcons/circle-plus.svg"
                        type="submit"
                        variant="white-round"
                        (click)="addItem(selectedFliControlIndex)"
                    >
                        {{ 'aumico_notes_add_more_movement' | i18next }}
                    </ham-button>
                    <div class="line"></div>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="add-component-section" *ngIf="movementScheduleForm.get('selectedFlis')['controls']?.length === 0">
    <div class="line"></div>
    <ham-button icon="assets/hamIcons/circle-plus.svg" type="submit" variant="white-round" (click)="addItem(0)">
        {{ 'aumico_notes_add_more_movement' | i18next }}
    </ham-button>
    <div class="line"></div>
</div>

<ham-confirm-decline-modal
    *ngIf="showFliDeletionConfirmationDialog"
    (cancel)="onCancelFliDeletionConfirmationDialog()"
    (action)="remove()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_notes_fli_component_remove_fli_confirmation_text' | i18next"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
